import { connect, ConnectedProps } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';

import { StateType } from '../../../state/state.types';
import { searchNext } from '../../state/actions';

const mapState = ({ queryParams, results, search }: StateType) => ({
  type: queryParams.type,
  searchLoading: results.searchLoading,
  paginationLoading: results.paginationLoading,
  loaded: results.loaded,
  totalHits: results.totalHits,
  hasResults: results.totalHits > 0,
  endOfResults: results.theEnd && !results.error && !results.resultsWasCut,
  error: results.error,
  searchTime: results.searchTime,
  sortType: queryParams.sort,
  hits: results.hits,
  ended: results.theEnd,
  enableAdvice: search.enableAdvice,
  enableSnippets: search.enableSnippets,
  exceptExpressions: results?.exceptExpressions,
});

const mapDispatch = (dispatch: ThunkDispatch<StateType, {}, AnyAction>) => ({
  needMoreHits() {
    dispatch(searchNext());
  },
});

export const Connect = connect(mapState, mapDispatch);

export type PropsFromRedux = ConnectedProps<typeof Connect>;
